import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import { CandidateReference, GdprRequest, UserReference } from '@recruitee/http/types';

export type GdprRequestReferences = CandidateReference | UserReference;

@Injectable({ providedIn: 'root' })
export class GdprRequestHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(
    candidateId: number,
  ): Observable<{ requests: GdprRequest[]; references: GdprRequestReferences[] }> {
    return this.httpApi.get(`gdpr/candidates/${candidateId}/requests`);
  }

  public complete(
    requestId: number,
  ): Observable<{ request: GdprRequest; references: GdprRequestReferences[] }> {
    return this.httpApi.post(`gdpr/requests/${requestId}/complete`);
  }
}
